import { createApiSaga } from '../../sagaGenerator';
import { apiDelete, apiGet, apiPatch } from '../../../middleware/api';
import {
  EARTHQUAKE_DATA_DELETE_EARTHQUAKE_REQUEST,
  EARTHQUAKE_DATA_DELETE_EARTHQUAKE_SUCCESS,
  EARTHQUAKE_DATA_DELETE_EARTHQUAKE_FAILURE,
  EARTHQUAKE_DATA_REGION_REQUEST,
  EARTHQUAKE_DATA_REGION_SUCCESS,
  EARTHQUAKE_DATA_REGION_FAILURE,
  EARTHQUAKE_DATA_BULK_EDIT_FAILURE,
  EARTHQUAKE_DATA_BULK_EDIT_REQUEST,
  EARTHQUAKE_DATA_BULK_EDIT_SUCCESS,
} from './earthquakeDataReducer';

const bulkEditEarthquakesSaga = createApiSaga({
  apiFunction: apiPatch,
  generateApiConfig: action => ({ endpoint: '/earthquakes', ...action }),
  requestType: EARTHQUAKE_DATA_BULK_EDIT_REQUEST,
  successType: EARTHQUAKE_DATA_BULK_EDIT_SUCCESS,
  failureType: EARTHQUAKE_DATA_BULK_EDIT_FAILURE,
  successMessage: 'Saved',
});

const deleteEarthquakeSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}`, ...action }),
  requestType: EARTHQUAKE_DATA_DELETE_EARTHQUAKE_REQUEST,
  successType: EARTHQUAKE_DATA_DELETE_EARTHQUAKE_SUCCESS,
  failureType: EARTHQUAKE_DATA_DELETE_EARTHQUAKE_FAILURE,
  successMessage: 'Deleted',
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/regions', ...action }),
  requestType: EARTHQUAKE_DATA_REGION_REQUEST,
  successType: EARTHQUAKE_DATA_REGION_SUCCESS,
  failureType: EARTHQUAKE_DATA_REGION_FAILURE,
});

export const earthquakeDataSagas = [
  bulkEditEarthquakesSaga,
  deleteEarthquakeSaga,
  getRegionsSaga,
];
